export type ConfigMeta = {
  entityType?: string | null
}

export const parseConfigMeta = (rawValue: string | null | undefined): ConfigMeta => {
  if (!rawValue) return {}
  try {
    const parsed = JSON.parse(rawValue) as unknown
    if (typeof parsed === 'object' && parsed !== null) {
      return parsed as ConfigMeta
    }
    return {}
  } catch {
    return {}
  }
}

export const getEntityTypeName = (configMeta: string | null | undefined): string | undefined => {
  const entityType = parseConfigMeta(configMeta).entityType?.trim()
  return entityType || undefined
}

export const formatPermissionResourceLabel = (
  resourceKind: 'Data Asset' | 'File Template',
  name: string | null | undefined,
  entityTypeName: string | null | undefined
): string => {
  const resourceName = name?.trim() || '-'
  const entityType = entityTypeName?.trim()
  return entityType ? `${resourceKind}: ${resourceName} (${entityType})` : `${resourceKind}: ${resourceName}`
}
